import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorage {

    get(key: string, defaults: any = null): any {
        let value = sessionStorage.getItem(key);
        if (value === null) return defaults;

        return JSON.parse(value);
    }

    has(key: string) {
        return sessionStorage.getItem(key) !== null;
    }

    set(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    remove(key: string) {
        sessionStorage.removeItem(key);
    }

    clear() {
        sessionStorage.clear();
    }

}